import { render } from "./PlsResourceNoScan.vue?vue&type=template&id=0e207eb1&scoped=true"
import script from "./PlsResourceNoScan.vue?vue&type=script&lang=js"
export * from "./PlsResourceNoScan.vue?vue&type=script&lang=js"

import "./PlsResourceNoScan.vue?vue&type=style&index=0&id=0e207eb1&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e207eb1"]])

export default __exports__